import React from "react";

export default function BrandLogo({
  size = 120,
  className = "",
  alt = "APMERCL — Andhra Pradesh Medical Education & Research Corporation Ltd",
  testId = "apmercl-logo",
  style,
  plate = false,
}) {
  const dim = size === "auto" ? undefined : (typeof size === "number" ? `${size}px` : size);
  const img = (
    <img
      src="/img/apmercl-logo.png"
      alt={alt}
      data-testid={testId}
      className={`brand-logo ${className}`}
      style={{ width: dim, height: "auto", maxWidth: "100%", objectFit: "contain", display: "block", ...style }}
    />
  );
  if (!plate) return img;
  return <div className="logo-plate">{img}</div>;
}
